import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "myMessages" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_slide_group_item = _resolveComponent("v-slide-group-item")!
  const _component_v_slide_group = _resolveComponent("v-slide-group")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      (_ctx.type === 'Document')
        ? (_openBlock(), _createBlock(_component_v_slide_group, {
            key: 0,
            class: "custom-carousel",
            "show-arrows": "",
            "center-active": ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.possibilities, (possibility, index) => {
                return (_openBlock(), _createBlock(_component_v_slide_group_item, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      class: "mx-1 my-3",
                      size: "x-small",
                      elevation: "0",
                      onClick: ($event: any) => (_ctx.insertQuestion(possibility))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate(possibility)), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event)),
        "max-width": !_ctx.$vuetify.display.mobile ? '650px' : undefined,
        fullscreen: _ctx.$vuetify.display.mobile,
        "hide-overlay": _ctx.$vuetify.display.mobile,
        onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.dialog = false), ["esc"])),
        title: _ctx.titleDialog,
        onValid: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sendAsk())),
        "valid-text": "Send"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-end"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.defaultQuestion(_ctx.askSelected)) + _toDisplayString(_ctx.question), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea, {
                    modelValue: _ctx.question,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.question) = $event)),
                    label: "Ecrivez votre propre message",
                    rows: "3"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "max-width", "fullscreen", "hide-overlay", "title"])
    ]),
    _: 1
  }))
}